angular.module('CarsSaraBo').factory('InsurancePriceService', ['$resource', function($resource) {
  return $resource('../rest/company/:companyOid/insurancePrice/:oid', 
    { companyOid : '@companyOid', oid : '@oid' },
    {
    	post : {method:'POST'},
    	update : { method: 'PUT' },
    	remove : { method: 'DELETE' },
    	get: {method:'GET', isArray:true}
    }
  )}
]);




//////////////////
// WEBPACK FOOTER
// ./public/app/models/insurance_price_service.js
// module id = 852
// module chunks = 3